module.exports = __webpack_public_path__ + "static/media/FreshSpire-Brandmark_Combination-Green.8c8c98df.png";